export const tableFieldClaims = [
  { text: 'langkey.status', align: 'center', value: 'status' },
  { text: 'langkey.order-id', align: 'center', value: 'orderId' },
  { text: 'langkey.date', align: 'center', value: 'date' },
  { text: 'langkey.delivery-address', align: 'center', value: 'address' },
  { text: 'langkey.note', align: 'center', value: 'note' },
  { text: 'langkey.supplier', align: 'center', value: 'supplier' },
];